import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingColumnTypeModelSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    type: z.string()
  })
  .strict()

const ReportingColumnTypeModelFields = makeFieldKeys(ReportingColumnTypeModelSchema)

type ReportingColumnTypeModel = z.infer<typeof ReportingColumnTypeModelSchema>
